import React from 'react';
import FieldGroup from './FieldGroup';
import { getErrorValue } from '../../utils/utility';

// FRS 4.2.3 (4.1) - Carbon Footprint of Product fields (value + unit).
// Exported as a render function (not a component) so the FieldGroup
// elements become direct children of <Form> and get registered by deepMap.
export const CFP_UNITS = ['kg', 'm2', 'm3', 'piece', 'kWh'];

export const cfpFieldGroups = ({ cfp_value, cfp_unit, disabled, fieldErrors, t }) => {
  const customAttr = { disabled };
  return [
    <FieldGroup
      key="cfp_value"
      id="cfp-value"
      field="cfp_value"
      type="number"
      label={<span>{t('cfp')} ({t('kgCO2eq per unit')})</span>}
      placeholder="0"
      help={t('cfp help')}
      value={cfp_value === undefined ? 0 : cfp_value}
      validators={[]}
      errorMessage={getErrorValue(fieldErrors, 'cfp_value')}
      {...customAttr}
    />,
    <FieldGroup
      key="cfp_unit"
      id="cfp-unit"
      field="cfp_unit"
      componentClass="select"
      label={t('cfp unit')}
      value={cfp_unit || 'kg'}
      validators={[]}
      errorMessage={getErrorValue(fieldErrors, 'cfp_unit')}
      {...customAttr}
    >
      {CFP_UNITS.map(u => (
        <option key={u} value={u}>{u}</option>
      ))}
    </FieldGroup>,
  ];
};



// WEBPACK FOOTER //
// ./src/components/field_group/CFPFields.js